export default {
  props: {
    imageDesktop: {
      type: String,
      required: false,
      default: () => "/images/regalando-ahora-vuelvo-mama.webp"
    },
    imageMobile: {
      type: String,
      required: false,
      default: () => "/images/regalando-ahora-vuelvo-mama-mobile.webp" 
    },
    title: {
      type: String,
      required: false,
      default: function() {
        return this.$t('give_away_avm.title');
      }
    }
  },
  created() {},
  methods: {
    gotogift(){
      this.$router.push('/regala')
    }
  },
};
